import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { useModalService } from "./../../../ricos-modals/modal-service-provider.js";
import { SelectableOptionsList } from "./../../selectable-options-list.js";
import { DropdownModal } from "../../dropdown-modal/dropdown-modal.js";
import { DEFAULT_OPTIONS, NODE_SIZE_BUTTONS } from "./consts.js";
const NodeSizeDropdown = ({
  modalId,
  getSelectedSize,
  onClick,
  options: optionsOverride
}) => {
  const { t } = useContext(RicosContext);
  const modalService = useModalService();
  const options = (optionsOverride ?? DEFAULT_OPTIONS).map((option) => NODE_SIZE_BUTTONS[option]);
  return /* @__PURE__ */ React.createElement(
    DropdownModal,
    {
      onCloseButtonClick: () => modalService.closeModal(modalId),
      title: t("ButtonModal_Size_Section"),
      options: /* @__PURE__ */ React.createElement(
        SelectableOptionsList,
        {
          options,
          selectedId: getSelectedSize(),
          onChange: (value) => onClick(value)
        }
      )
    }
  );
};
export {
  NodeSizeDropdown
};
//# sourceMappingURL=node-size-dropdown.js.map
